;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);
	var $container = $('.section-masonry');
  
	var isMobile = {
	    Android: function() {
	        return navigator.userAgent.match(/Android/i);
	    },
	    BlackBerry: function() {
	        return navigator.userAgent.match(/BlackBerry/i);
	    },
	    iOS: function() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	    },
	    Opera: function() {
	        return navigator.userAgent.match(/Opera Mini/i);
	    },
	    Windows: function() {
	        return navigator.userAgent.match(/IEMobile/i);
	    },
	    any: function() {
	        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	    }
	};

	$doc.ready(function() {
      

		var activeTabClass = 'current';

		$('.fullscreen-img').fullscreener();

		if ( $('.img-holder').length ){
			$('.img-holder').each(function(){
				var this_ = $(this);
              	
              	this_.find('img').appendTo(this_);
              	this_.find('p').remove();

				this_.append('<p class="img-alt">' + this_.find('img').attr('alt') + '</p>');
			})
		};

		$doc.on('click', '.sproduct-actions .box a', function(e){
			e.preventDefault();
			var this_ = $(this);
			var field = this_.parent('.box').find('.field-quantity');
			var fieldVal = field.val();
			var newVal;

			if ( this_.is('.qy-plus') ){
				newVal = parseFloat(fieldVal) + 1;
			}else if ( this_.is('.qy-minus') && fieldVal > 0 ){
				newVal = parseFloat(fieldVal) - 1;
			}else{
				newVal = 0;
			}

			field.val(newVal);
          	field.trigger('keyup');
		});

// 		$('.delete-sproduct').on('click', function(e){
// 			e.preventDefault();
// 			$(this).parents('.sproduct, .item').fadeOut();
// 		});

		$('.sm-link').on('click', function(e){
			e.preventDefault();

			$('.product-list-container').toggleClass('with-smenu');
			$(this).toggleClass('active');
		});

      $('.dd .dd-link').on('click', function(e){
			e.preventDefault();
			var dd = $(this).parent('.dd');
			
			dd.toggleClass('show-dd');
        
			if ( dd.is('.dd-accc') ){
				$('.header').toggleClass('show-login');
              	$('html').toggleClass('no-scroll');
              	if($('.header-floating').css('visibility')==='hidden'){
                  $('.header-floating').toggle();
                }
			}
        
            if ( dd.is('.dd-acccc') ){
				location.href = '/account';
            }
		});

		$('.product-aside-menu li a').on('click', function(e){

			var li = $(this).parent('li');
			var liMenu = li.find('ul');

			if ( liMenu.length && !li.is('.current') ) {
				e.preventDefault();
				li.addClass(activeTabClass).siblings().removeClass(activeTabClass).find('ul').slideUp();
				liMenu.slideDown();
			}else{
              	if(liMenu.length) e.preventDefault();
				li.removeClass(activeTabClass);
				liMenu.slideUp();

			}
		});

		$('.ct-feat .customer a').on('click', function(e){
			e.preventDefault();

			var customer = $(this).parents('.testimonial-wrap');

			if ( !customer.is(activeTabClass) ){
				customer.addClass(activeTabClass).siblings().removeClass(activeTabClass);
			}
		});

		$('.scroll-to').on('click', function(e){
			e.preventDefault();

			$('html, body').animate({
			    scrollTop: $( $(this).attr('href') ).offset().top - $('.header').height()
			}, 1000);
		});

		$('.header-search .searchform').on('submit', function(e){
			var hSearch = $(this).parents('.header-search');
			if ( !hSearch.is('.visible') ){
				e.preventDefault();
				hSearch.addClass('visible');
				hSearch.find('.field-wrap input').focus();
			}
		});

		$('.header-search .search-label a').on('click', function(e){
          	e.preventDefault();
          
			var hSearch = $(this).parents('.header-search');
			if ( !hSearch.is('.visible') ){
				hSearch.addClass('visible');
				hSearch.find('.field-wrap input').focus();
            } else {
            	$('.header-search .searchform').trigger('submit');
            }
		});

		$('.menu-trigger').on('click', function(e){
			e.preventDefault();

			$('.header').toggleClass('show-menu');
		});

		$('.nav a').on('click', function(e){
			var li = $(this).parent('li');

			if ( !li.is('.show-ul') && li.find('ul').length && $win.width() < 980 ){
				e.preventDefault();
				li.addClass('show-ul').siblings('.show-ul').removeClass('show-ul');
			}else if ( li.is('.back') ){
				e.preventDefault();
				li.parents('.show-ul').removeClass('show-ul');
			}else{
				li.removeClass('show-ul');
			}
		})


		$(document).keyup(function(e) {
			if ( e.keyCode == 27 ){
				
				$('.header').removeClass('show-login show-menu');
				$('.dd').removeClass('show-dd');
				$('.header-search').removeClass('visible');
				$.magnificPopup.close();
			}
		});

      $('select:not(#product-select)').selecter();

		$('.video-popup-link').magnificPopup({
			type: 'iframe',
			removalDelay: 300,
  			mainClass: 'mfp-fade',
  			iframe: {
     			markup: 
     					'<div class="mfp-iframe-scaler">'+
		                	'<div class="mfp-close"></div>'+
		                	'<div class="mfp-title">Some caption</div>'+
		                	'<div class="mfp-video-iframe-holder">'+
				                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
	              			'</div>'+
              			'</div>'
  			},
  			callbacks: {
    			markupParse: function(template, values, item) {
	     			values.title = item.el.attr('title');
	    		}
	  		}
		});

      	$doc.on('click', '.popup-inline-link', function() {
          $('.popup-inline-link').magnificPopup({
            type:'inline',
            removalDelay: 300,
            mainClass: 'mfp-fade'
          });
          $(this).trigger('click');
        });

      	$(".product-img-zoom").elevateZoom({
            responsive: true,
			zoomType: "inner",
			borderSize: 0,
			lensBorder: 0,
          	zoomEnabled: false
		});

		
//       if ( !navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i) ) {
// 		$(".product-img-zoom").elevateZoom({
// 			responsive: true,
// 			zoomType: "inner",
// 			borderSize: 0,
// 			lensBorder: 0,
// 		});
//       }
	});

	$win
		.on('load', function(){
      
      if (!$('body.template-article').length){
			$('.gallery-slider .slides').bxSlider({
				pager: false,
				nextSelector: '.gallery-slider .slider-controls',
				prevSelector: '.gallery-slider .slider-controls'
			});
      } else {
			$('.gallery-slider-1 .slides').bxSlider({
				pager: false,
				nextSelector: '.gallery-slider-1 .slider-controls',
				prevSelector: '.gallery-slider-1 .slider-controls'
			});
      
			$('.gallery-slider-2 .slides').bxSlider({
				pager: false,
				nextSelector: '.gallery-slider-2 .slider-controls',
				prevSelector: '.gallery-slider-2 .slider-controls'
			});
      
			$('.gallery-slider-3 .slides').bxSlider({
				pager: false,
				nextSelector: '.gallery-slider-3 .slider-controls',
				prevSelector: '.gallery-slider-3 .slider-controls'
			});
      }

			$('.slider-feed .slides').bxSlider({
				pager: false,
				nextSelector: '.slider-feed .slider-controls',
				prevSelector: '.slider-feed .slider-controls',
              	adaptiveHeight: true
			});

			$('.slider-reviews .slides').bxSlider({
				pager: false,
				nextSelector: '.slider-reviews .slider-controls',
				prevSelector: '.slider-reviews .slider-controls',
              	adaptiveHeight: true
			});

			if ( $('.map').length ){
				$('.map').each(function(){
					var adress = $(this).data('address'),
						map_id = $(this).attr('id');

					var latLong = adress.split(',');

					var latlng = new google.maps.LatLng(parseFloat(latLong[0]) , parseFloat(latLong[1]));

					var myOptions = {
						zoom: 16,
					    center: latlng,
					    mapTypeId: google.maps.MapTypeId.ROADMAP,
					    mapTypeControl: false,
					    streetViewControl: false,
					    zoomControl: false,
					};

					var map = new google.maps.Map(document.getElementById(map_id),myOptions);

					var marker = new google.maps.Marker({
					  position: latlng,
					  map: map
					});
				});
			};

			$('body').removeClass('no-transition')

		})
		.on('scroll load', function(){
			
			var windowScroll = $win.scrollTop();
			var top;

			if ( $('.wrapper').is('.wrapper-parallax-banner') && $win.width() > 979 ){ 
	 	    	top = $('.container').offset().top - 450 
	 	    }else{ 
	 	    	top = 50
	 	    }

			if ( windowScroll > top ){
				$('.header').addClass('floating');
			}else{
				$('.header').removeClass('floating');
			};

			$('.nav').addClass('no-transition'); //will disable it
			setTimeout(function() {
				$('.nav').removeClass('no-transition'); //will enable it
			}, 1);
		})
		.on('load resize', function(){

      		var $container = $('.section-masonry');
      
				skrollr.init({
					forceHeight: false,
					mobileCheck: function() {
			            //hack - forces mobile version to be off
			            return false;
			        }
				});
			
			// initialize Isotope
			var column;
			if ( $win.width() > 739 ){
				column = 4;
			}else {
				column = 2;
			}
			$container.isotope({
				resizable: false,
				masonry: { columnWidth: $container.width() / column}
			});

		});

})(jQuery, window, document);